<template>
  <div class="card shadow-sm mb-3">
    <div class="card-header d-flex align-items-center">
      <!-- <i class="ti ti-calendar-month text-info mr-2"></i> -->
      🗓 <span>Periode</span>
    </div>

    <div class="card-body">
      <date-picker
        v-model="model"
        :default-value="model"
        :disabled-date="disabledDate"
        :clearable="false"
        value-type="format"
        type="month"
        format="MM/YYYY"
        confirm
        style="width: 100%"
        @change="onChange"
      />

      <small class="text-muted d-block mt-2">
        Pilih periode untuk melihat dan mengatur jadwal shift.
      </small>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/id";

export default {
  name: "PeriodPanel",

  components: {
    DatePicker,
  },

  props: {
    value: {
      type: String,
      default: "",
    },
    disabledDate: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      model: this.value,
    };
  },

  watch: {
    value(v) {
      this.model = v;
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.model);
      this.$emit("change", this.model);
    },
  },
};
</script>